import { useLocation, Redirect } from "react-router-dom";

interface IProps {
  url: string;
  withRedirectUrlParam: boolean;
}

const RouterNavigation = (props: IProps) => {
  const location = useLocation();

  let redirectUrl = props.url;

  if (props.withRedirectUrlParam) redirectUrl += "?ru=" + location.pathname;

  return <Redirect to={redirectUrl} />;
};

export default RouterNavigation;
